/** Truncate filename for compact attachment chip (Figma: "New users data.."). */
export function truncateAttachmentFilename(name: string, maxLength = 20): string {
  const trimmed = name.trim();
  if (trimmed.length <= maxLength) return trimmed;
  return `${trimmed.slice(0, maxLength - 2)}..`;
}
